export default __webpack_public_path__ + "static/media/wordpress-icon.dd5917b0.svg";